import React, { useRef } from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IStore } from '../../../../../redux/store';
import Annex6V2Print from './Annex6V2Print';
import Annex6V2CoverPage from './Annex6V2CoverPage';
import { useOnScrollToTop } from '../../../../../hooks/useScrollToTop';
import { annex6V2Selectors } from '../../../../../redux/app/annex6-v2';

type OwnProps = {
    showCoverPages?: boolean;
	vesselId: string;
};
type Annex6V2HistoryProps = PropsFromRedux & OwnProps;

function Annex6V2InspectorView(props: Annex6V2HistoryProps) {
    const { historyList, showCoverPages = false, vesselId } = props;
    const topDivRef = useRef<HTMLDivElement | null>(null);
    useOnScrollToTop(topDivRef);

    return (
        <div>
            <div className="h-0" ref={topDivRef} />
            {showCoverPages ? <Annex6V2CoverPage vesselId={vesselId} /> : null}
            <div className="newpage">
                <Annex6V2Print
                    key={'temp-print-id'}
                    isPrintVisible={true}
                    annex6V2Records={historyList}
                    showShipInfo={showCoverPages}
					vesselId={vesselId}
                />
            </div>
        </div>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
    const annex6V2RecordStore = annex6V2Selectors._getStore(store);
    return {
        historyList: annex6V2Selectors.getHistoryList(annex6V2RecordStore),
        jobToLoadHistory:
            annex6V2Selectors.jobToLoadHistory(annex6V2RecordStore),
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
    return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(Annex6V2InspectorView);
